import { createBrowserHistory } from 'history';

const history = createBrowserHistory({
  window: window
});
export default history;
